import React from 'react';
import g from 'glamorous';
import Link from 'gatsby-link';
import { translate } from 'react-i18next';

import LanguageSwitcher from '../components/languageSwitcher';
import generalStyles from '../utils/generalStyles';

import logo from '../assets/svgs/logo.svg';
import facebookIcon from '../assets/svgs/facebook.svg';

const FooterArea = g.div({
  height: '8rem',
  backgroundColor: 'white',
  padding: '1.75rem 2rem',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  [generalStyles.mediaQueries.md]: {
    padding: '1.75rem 4rem'
  },
  [generalStyles.mediaQueries.xs]: {
    padding: '24px 0',
    justifyContent: 'center',
    '> a': {
      display: 'none'
    }
  },
  [generalStyles.mediaQueries.xxs]: {
    display: 'block',
    padding: '30px 40px'
  }
});

const Logo = g.img({
  height: '100%',
  [generalStyles.mediaQueries.xs]: {
    display: 'none'
  }
});

const FooterWrapper = g.div({
  position: 'relative',
  zIndex: 1
});

const GeneralInfo = g.div({
  display: 'flex',
  flexDirection: 'column',
  [generalStyles.mediaQueries.xs]: {
    flex: '0 1 0%',
    width: '100%',
    '> div': {
      flex: 1,
      WebkitBoxFlex: '1',
      width: '100%'
    }
  },
  [generalStyles.mediaQueries.xxs]: {
    display: 'block'
  }
});
const GeneralInfoLine = g.div({
  [generalStyles.mediaQueries.xs]: {
    fontSize: '10px !important',
    textAlign: 'center',
    whiteSpace: 'nowrap'
  }
});
const ContactInfoLine = g.div({
  display: 'flex',
  justifyContent: 'space-between',
  [generalStyles.mediaQueries.xs]: {
    fontSize: '10px !important',
    '> a': {
      letterSpacing: 0.4
    }
  }
});

const SocialIconLink = g.a({
  display: 'inline-block'
});

const SocialIcon = g.img({
  display: 'block',
  height: '1.25rem',
  margin: 0
});

const Actions = g.div({
  position: 'absolute',
  top: -80,
  left: '50%',
  transform: 'translateX(-50%)',
  alignItems: 'center',
  height: '4rem',
  display: 'none'
});

class Footer extends React.Component {
  render() {
    const { t } = this.props;
    return (
      <FooterWrapper>
        <Actions css={generalStyles.visibility('xs', true, 'flex')}>
          <SocialIconLink href="https://www.facebook.com/PeriklisPasxakisLawFirm/" target="_blank">
            <SocialIcon src={facebookIcon} />
          </SocialIconLink>
          <LanguageSwitcher />
        </Actions>
        <FooterArea>
          <Link
            to="/"
            style={{
              position: 'relative',
              height: '100%',
              flex: '1'
            }}
            activeStyle={{ cursor: 'default' }}
            exact={true}
          >
            <Logo src={logo} />
          </Link>
          <GeneralInfo>
            <GeneralInfoLine className="color-aluminum weight-medium size-14 letter-spacing-bigger">
              {t('top_text')}
            </GeneralInfoLine>
            <ContactInfoLine className="color-aluminum weight-medium size-14">
              <a href="mailto:pp@paschakislaw.com" className="color-fiord">
                pp@paschakislaw.com
              </a>
              {'  '}|{'  '}
              <a href="tel:+306947808872" className="color-fiord">
                +30 6947 808872
              </a>
            </ContactInfoLine>
          </GeneralInfo>
        </FooterArea>
      </FooterWrapper>
    );
  }
}

export default translate()(Footer);



// WEBPACK FOOTER //
// ./src/components/footer.js